/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { createAndPublishListingFromMaster } from './createAndPublishListingFromMaster';

/**
 * Orchestration-only thunk: chains create + publish via publishDirectly API.
 */
export const createAndPublishVariantDraftsFromMaster = createAsyncThunk(
  'products/createAndPublishVariantDraftsFromMaster',
  async ({ productId, channelId, masterVariantIds }, { dispatch }) => {
    if (!masterVariantIds?.length) {
      throw new Error('No listing variants created');
    }

    return dispatch(createAndPublishListingFromMaster({
      productId,
      channelIds: [channelId],
      masterVariantIds,
    })).unwrap();
  },
);
